import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withStyles from 'react-jss';
import ComponentHeader from '../../ecap/ComponentHeader';
import BackArrow from '../../utility/BackArrow';
import ErrorMessage from '../../ErrorMessage';
import {
  labelAndFileSelector,
  checkboxAndLabel,
  checkJobStatusInterval,
  displayLoadingOrSuccess,
} from './modalUtil';
import {
  insertTenantTableData,
  uploadTenantPhotoToS3,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  checkJobStatus,
  updateTenantCareers,
  insertSkillsCourseRecommendations,
} from '../../../store/actions';

const fileCustom = {
  backgroundColor: (props) => ({
    '&::before': {
      backgroundColor: props.tenant?.primary || '#000000',
      content: `'Select'`,
      border: `1px solid $`,
    },
  }),
  button: (props) => ({
    backgroundColor: 'white',
    color: props.tenant?.primary || '#000000',
    border: `1px solid ${props.tenant?.primary || '#000000'}`,

    '&:hover': {
      backgroundColor: props.tenant?.primary || '#000000',
      border: `2px solid ${props.tenant?.primary || '#000000'}`,
      color: 'white',
    },
    '&:disabled': {
      color: 'black',
      border: 'none',
      backgroundColor: '#e5e5e5',
      padding: ' 0 34px',
      cursor: 'not-allowed',
    },
  }),
};
export class UpdateCareersModal extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      careers: null,
      careerCategories: null,
      relatedCareers: null,
      degreeTranslations: null,
      degrees: null,
      acknowledgement: false,
      loading: false,
      error: '',
      success: false,
    };
  }

  disabledButtonContainerStyle = {
    backgroundColor: 'white',
    border: `1px solid #E0E0E0`,
    cursor: 'not-allowed',
  };

  colorPrimary = {
    color: this.props.tenant.primary,
  };

  setFile = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  handleAcknowledgement = () => {
    this.setState((prevState) => ({
      acknowledgement: !prevState.acknowledgement,
    }));
  };

  isButtonDisabled = () => {
    const {
      careers,
      careerCategories,
      acknowledgement,
      degrees,
      degreeTranslations,
    } = this.state;
    if (this.props.tenant.name === 'ASU') {
      return (
        !careers || !careerCategories || !acknowledgement || !degreeTranslations
      );
    }
    return !careers || !careerCategories || !degrees;
  };

  saveButton = () => {
    return (
      <div className="tenant-modal__save-button-container">
        <button
          className={classNames(
            'button--primary',
            'tenant-modal__save-button',
            this.props.classes.button
          )}
          style={
            this.isButtonDisabled() ? this.disabledButtonContainerStyle : null
          }
          disabled={this.isButtonDisabled()}
          type="button"
          onClick={async () => {
            await this.handleUpdate();
          }}
        >
          Save
        </button>
      </div>
    );
  };

  handleUpdate = async () => {
    const { careers, careerCategories, relatedCareers } = this.state;
    let error, success;
    const jobIdentifier = `${this.state.name}_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '')}`;
    this.setState({
      loading: true,
      error: '',
      success: false,
    });

    const response = await this.props.updateTenantCareers(
      this.props.tenant.id,
      careers,
      careerCategories,
      relatedCareers,
      jobIdentifier,
      this.props.tenant.name === 'ASU' ? null : this.state.degrees,
      this.props.tenant.name === 'ASU' ? this.state.degreeTranslations : null
    );
    if (
      !!response?.status &&
      (response.status === 500 || response.status === 401)
    ) {
      error = response.data;
      this.setState({
        loading: false,
        error,
        success,
      });
      return;
    }
    const jobStatus = await checkJobStatusInterval(
      jobIdentifier,
      this.props.checkJobStatus
    );
    if (jobStatus.status !== 'SUCCESS') {
      error = `Something went wrong with the update. Status: '${jobStatus.error_message}'`;
    } else {
      success = true;
    }
    this.setState({
      loading: false,
      error,
      success,
    });
  };

  render() {
    return (
      <>
        <div
          className="tenant-modal__navigate-back"
          tabIndex={0}
          role="button"
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key))
              this.props.openTenantModal('Edit', this.props.tenant.id);
          }}
          onClick={() => {
            this.props.openTenantModal('Edit', this.props.tenant.id);
          }}
        >
          <BackArrow
            size="35px"
            color={this.props.tenant.primary}
            title="Left arrow"
          />
          <p
            className="tenant-modal__back-text"
            style={{ color: this.props.tenant.primary }}
          >
            Back
          </p>
        </div>
        {this.state.loading || this.state.success ? (
          displayLoadingOrSuccess(
            this.props.tenant.name,
            this.state.loading,
            this.state.success,
            'careers'
          )
        ) : (
          <>
            <ComponentHeader
              headerText={`Update Careers for ${this.props.tenant.name}`}
              tenant={this.props.tenant}
              marginTop="0px"
            />
            <div className="tenant-modal__edit-careers-container">
              {labelAndFileSelector(
                'Careers',
                'Data required for complete tenant updates. Requires CSV file.',
                'careers',
                this.setFile,
                this.state.careers,
                this.props.classes.backgroundColor
              )}
              {labelAndFileSelector(
                'Career Categories',
                'Data required for complete tenant updates. Requires CSV file.',
                'careerCategories',
                this.setFile,
                this.state.careerCategories,
                this.props.classes.backgroundColor
              )}
              {labelAndFileSelector(
                'Related Careers (Optional)',
                false,
                'relatedCareers',
                this.setFile,
                this.state.relatedCareers,
                this.props.classes.backgroundColor
              )}
              {this.props.tenant.name === 'ASU' && (
                <>
                  {labelAndFileSelector(
                    'Degrees Translations For PeopleSoft Degrees',
                    'Data required for complete tenant updates. Requires CSV file.',
                    'degreeTranslations',
                    this.setFile,
                    this.state.degreeTranslations,
                    this.props.classes.backgroundColor
                  )}
                  {checkboxAndLabel(
                    'By clicking this box I acknowledge that degrees will be pulled automatically from PeopleSoft.',
                    this.state.acknowledgement,
                    this.handleAcknowledgement
                  )}
                </>
              )}
              {this.props.tenant.name !== 'ASU' &&
                labelAndFileSelector(
                  'Degrees with Career Pairings',
                  'Data required for complete tenant updates. Requires CSV file.',
                  'degrees',
                  this.setFile,
                  this.state.degrees,
                  this.props.classes.backgroundColor
                )}
              {!!this.state.error && <ErrorMessage error={this.state.error} />}
              {this.saveButton()}
            </div>
          </>
        )}
      </>
    );
  }
}

export default connect(null, {
  uploadTenantPhotoToS3,
  insertTenantTableData,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  updateTenantCareers,
  checkJobStatus,
  insertSkillsCourseRecommendations,
})(withStyles(fileCustom)(UpdateCareersModal));
